<template>
<span>
    <Button :icon="icon" class="buttoncolor" style="width:90px;"  @click="onClick">
        <slot>
        {{label}}
        </slot>
    </Button>
</span>
</template>

<script>

export default {
    name: 'buttonSub',
    components: {
    },
    props: {
        label: {
            type: String,
            default: '确定'
        },
        icon: {
            type: String,
            default: 'ios-checkmark-circle'
        },
        loading: {
            type: Boolean,
            default: false
        },
    },
    data () {
        return {
        };
    },
    watch: {
    },
    created () {
    },
    mounted () {
    },
    methods: {
        onClick() {
            this.$emit('click')
        }
    },

};
</script>
<style lang="less">
.buttoncolor{
  background-color: #0ba129;
  color: #f6f8f7;
}
</style>


